<template>
  <b-button
    variant="info"
    @click="edit"
  >
    編集
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'seatingStatus',
    }
  },

  methods: {
    edit () {
      this.$store.commit(`${this.modelName}/setAttr`, {
        name: 'isEdit',
        value: true
      })
    }
  }
}
</script>
